import { format, formatRelative, isToday } from 'date-fns';

type FormatParams = { formatStr?: string; showRelativeToday?: boolean };

export const utilFormatDate = (date: string | null | undefined, formatParams?: FormatParams) => {
  const { formatStr, showRelativeToday } = formatParams || {
    formatStr: 'dd MMMM yyyy',
    showRelativeToday: false,
  };

  if (date) {
    let time = '';

    if (isToday(new Date(date)) && showRelativeToday) {
      time = formatRelative(new Date(date), new Date(), {
      });

      time = time[0].toUpperCase() + time.substring(1);
    }

    if (time !== '') {
      return (
        `${time}, `
        + `${format(new Date(date), formatStr, {
        })}`
      );
    }

    return `${format(new Date(date), formatStr, {
    })}`;
  }

  return '';
};

export const sortDates = (
  currentDate: string | Date,
  nextDate: string | Date,
  direction: 'asc' | 'desc',
) => {
  const createdCur = new Date(currentDate);
  const createdNxt = new Date(nextDate);

  switch (direction) {
    case 'asc': {
      if (createdCur > createdNxt) return -1;
      if (createdCur < createdNxt) return 1;
      return 0;
    }

    case 'desc': {
      if (createdCur < createdNxt) return -1;
      if (createdCur > createdNxt) return 1;
      return 0;
    }

    default: {
      if (createdCur > createdNxt) return -1;
      if (createdCur < createdNxt) return 1;
      return 0;
    }
  }
};
